export const OUR_TEAM_AUGMENTATION_PROCESS = [
    {
        number: 1,
        header: "Introductory meeting. Outlining requirements",
        text: "We analyze your project idea or existing development needs together and offer you the best-matching team setup.",
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/team_augmentation/teamaugmentation3.webp"
    },
    {
        number: 2,
        header: "Building a team for you",
        text: "We do interview sessions with potential candidates, ensuring that we select the best individuals with strong technical and soft skills that align with your specific needs. The final decision remains entirely in your hands, allowing for additional interviews on your side if necessary.",
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/team_augmentation/teamaugmentation4.webp"
    },
    {
        number: 3,
        header: "Kicking off",
        text: "We onboard your chosen development team and get the project rolling.",
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/team_augmentation/teamaugmentation5.webp"
    },
    {
        number: 4,
        header: "Sustained Team Support",
        text: "We provide your dedicated team with a wide range of services including comfortable office space, HR support, workshops, mentorships, performance reviews, regular English classes and accounting services.",
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/team_augmentation/teamaugmentation6.webp"
    }
]
